import React from 'react';
import { AlertTriangle, LogOut, UserX } from 'lucide-react';

const fmtDateTime = (iso) => {
  if (!iso) return '—';
  try {
    return new Date(iso).toLocaleString('vi-VN', { dateStyle: 'short', timeStyle: 'short' });
  } catch {
    return String(iso);
  }
};

/**
 * Màn khi cha trực tiếp (1 cấp) đang bị khóa. Cascade chỉ 1 cấp — không walk-up.
 */
const ParentLockedScreen = ({ detail, onBack }) => {
  const ancestor = detail?.ancestor || {};
  const ancestorLabel = [ancestor.code, ancestor.facebook].filter(Boolean).join(' - ') || ancestor.userName || 'Cấp trên';

  return (
    <div className="min-h-screen bg-gradient-to-br from-yellow-50 via-amber-50 to-orange-50 flex items-center justify-center p-4">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-2xl overflow-hidden">
        <div className="bg-gradient-to-r from-amber-500 to-orange-500 px-6 py-8 text-center">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-white/20 rounded-full mb-4">
            <AlertTriangle className="w-10 h-10 text-white" />
          </div>
          <h1 className="text-2xl font-bold text-white">Cấp trên đang bị khóa</h1>
          <p className="text-amber-50 text-sm mt-1">Bạn bị khóa theo</p>
        </div>

        <div className="p-6 space-y-4">
          <div className="bg-amber-50 border-l-4 border-amber-500 p-3 rounded">
            <div className="text-sm font-bold text-gray-800 flex items-center gap-2 mb-1">
              <UserX className="w-4 h-4 text-amber-600" />
              {ancestorLabel}
            </div>
            {ancestor.lockReason && (
              <div className="text-xs text-gray-700">
                <span className="font-semibold">Lý do:</span> {ancestor.lockReason}
              </div>
            )}
            {ancestor.lockedAt && (
              <div className="text-xs text-gray-500 mt-1">
                Khóa từ: {fmtDateTime(ancestor.lockedAt)}
              </div>
            )}
          </div>

          <div className="text-sm text-gray-700 text-center">
            Vui lòng liên hệ <strong>quản trị</strong>.
          </div>

          <button
            onClick={onBack}
            className="w-full flex items-center justify-center gap-2 bg-gray-100 hover:bg-gray-200 text-gray-700 font-medium py-2.5 px-4 rounded-lg transition"
          >
            <LogOut className="w-4 h-4" />
            Quay lại đăng nhập
          </button>
        </div>
      </div>
    </div>
  );
};

export default ParentLockedScreen;
